<template>
  <main>
    <section class="whiteBox">
      <div class="content">
        <h1>{{$t('search.title')}}</h1>
        <br>
        <p class="accentuate">{{$t('search.search')}}</p>
        <input
          type="text"
          v-model="lookFor"
        />
        <br><br>
        <p>{{$t('search.in')}}:</p>
        <div class="row">
          <input
            type="checkbox"
            value="users"
            v-model="into.users"
          >
          <p>{{$t('search.users')}}, {{$t('search.profils')}}</p>
        </div>
        <div class="row">
          <input
            type="checkbox"
            value="campaigns"
            v-model="into.campaigns"
          >
          <p>{{$t('search.campaigns')}}</p>
        </div>
        <!--    <div class="row">
          <input
            type="checkbox"
            value="customerId"
            v-model="into.customerReferences"
          >
          <p>{{$t('search.idClient')}}</p>
        </div>
        <div class="row">
          <input
            type="checkbox"
            value="transactionsId"
            v-model="into.transactionReferences"
          >
          <p>{{$t('search.idTransactions')}}</p>
        </div>-->
        <br>
        <button @click="search()">{{$t('button.search')}}</button>
      </div>
      <hr v-if="onSearch">
      <div
        class="content"
        v-if="onSearch"
      >
        <p>{{totalResult}} {{$t('search.results')}}</p><br>
      </div>
    </section>
    <!-- User Results -->
    <section
      class="whiteBox"
      v-if="into['users']&&usersFilter.length>0"
    >
      <div class="content">
        <div>
          <p class="accentuate">{{$t('search.users')+' - '+usersFilter.length+' '+ $t('search.results')}} </p>
        </div>

        <div class="row">
          <table>
            <thead>
              <tr class="trHead">
                <th></th>
                <th v-if="$store.getters.USERPROFILE['user-profile-administration']"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="user in usersFilter"
                :key="user.id"
              >
                <td>
                  {{user['first-name']}} {{user.name}} ({{user['user-profile-name']}}) - {{user.email}}
                </td>
                <td class="bubbleParent">
                  <button
                    ref="bubble"
                    class="outline"
                    @click="bubbleClick('user'+user.id)"
                  >
                    <img
                      ref="bubble"
                      class="pastille"
                      src="@/assets/images/pastille.png"
                      alt="pastille"
                    >
                  </button>
                  <div
                    class="bubble"
                    v-if="bubbleAction('user'+user.id)"
                  >
                    <a @click="diplayUserDetailsbyId(user.id)">{{$t('button.userDetails')}}</a>
                    <!-- <a
                    class="redText"
                    v-if="!user['all-campaigns-access']&&parUserPageRights"
                    @click="removeUser(user.id)"
                  >{{$t('button.revoqueUser')}}</a>-->
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- user details display -->
      <UserDetails
        v-if="displayUserDetails"
        :parUserId="this.currentUser"
        @close="displayUserDetails = false"
      ></UserDetails>
    </section>

    <!-- Campaign Results-->
    <section
      class="whiteBox"
      v-if="into['users']&&campaignsFilter.length>0"
    >
      <div class="content">
        <div>
          <p class="accentuate">{{$t('search.campaigns')+' - '+campaignsFilter.length+' '+ $t('search.results')}} </p>
        </div>

        <div class="row">
          <table>
            <thead>
              <tr class="trHead">
                <th></th>
                <th v-if="$store.getters.USERPROFILE['user-profile-administration']"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="campaign in campaignsFilter"
                :key="campaign.id"
              >
                <td>
                  {{campaign['name']}} ({{campaign['global-code']}})
                </td>
                <td
                  v-if="campaign.status!=0"
                  class="bubbleParent"
                >
                  <button
                    ref="bubble"
                    class="outline"
                    @click="bubbleClick('campaign'+campaign.id)"
                  >
                    <img
                      ref="bubble"
                      class="pastille"
                      src="@/assets/images/pastille.png"
                      alt="pastille"
                    >
                  </button>
                  <div
                    class="bubble"
                    v-if="bubbleAction('campaign'+campaign.id)"
                  >
                    <a
                      @click="$router.push({name: 'detailUniqueCampaign', params: { id: campaign.id}})"
                      v-if="campaign.status !=0 && campaign['campaign-type-global']"
                    >{{$t('search.campaignDetails')}}
                    </a>
                    <a
                      @click="$router.push({name: 'detailGroupCampaign', params: { id: campaign.id}})"
                      v-if="campaign.status !=0 && !campaign['campaign-type-global']"
                    >{{$t('search.campaignDetails')}}
                    </a>

                  </div>
                </td>
                <td v-else></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>

  </main>
</template>

<script>
import getUsers from "@/mixins/getUsers";
import bubble from "@/mixins/bubble";
import UserDetails from "@/components/users/UserDetails";
import getCampaigns from "@/mixins/getCampaigns";
export default {
  mixins: [getUsers, bubble, getCampaigns],
  components: { UserDetails },
  data() {
    return {
      //Menu management
      displayUserDetails: false,
      currentUser: "",
      onSearch: false,
      lookFor: "",
      lookInFor: "",
      into: {
        users: false,
        campaigns: false,
        customerReferences: false,
        transactionReferences: false
      }
    };
  },
  computed: {
    usersFilter: function() {
      return this.users.filter(data => {
        let look = this.lookInFor.toLowerCase();
        let name = data["name"].toLowerCase();
        let firstName = data["first-name"].toLowerCase();
        let email = data["email"].toLowerCase();
        if (
          name.includes(look) ||
          firstName.includes(look) ||
          email.includes(look)
        ) {
          return true;
        } else {
          return false;
        }
      });
    },
    campaignsFilter: function() {
      return this.campaigns.filter(data => {
        let look = this.lookInFor.toLowerCase();
        let name = data["name"].toLowerCase();
        let description = "";
        if (data["description"])
          description = data["description"].toLowerCase();
        let globalCode = "";
        if (data["campaign-type-global"] && data["global-code"])
          globalCode = data["global-code"].toLowerCase();
        if (
          name.includes(look) ||
          (data["campaign-type-global"] && globalCode.includes(look)) ||
          description.includes(look)
        ) {
          return true;
        } else {
          return false;
        }
      });
    },
    totalResult: function() {
      return this.usersFilter.length + this.campaignsFilter.length;
    }
  },
  methods: {
    diplayUserDetailsbyId(userid) {
      this.currentUser = userid;
      this.displayUserDetails = true;
    },
    search() {
      this.onSearch = true;
      if (this.into["users"]) {
        this.getUsers();
      }
      if (this.into["campaigns"]) {
        this.getCampaigns();
      }
      this.lookInFor = this.lookFor;
    }
  }
};
</script>